import { IconEdit01, IconTrash01 } from "@pentabd/icons";
import { Text } from "@pentabd/ui";
import { UnitType } from "@type/inventory/unit";
import { TFunction } from "i18next";
import { SetStateAction } from "react";

export const UnitTableColumn = (
  t: TFunction<"translation", undefined>,
  openConfirmationModel: (itemName: string, id: string | number) => void,
  unitFetchByIdActionHandler: (id: string | number) => void,
  handleScrollToTop: () => void,
) => {
  return [
    {
      id: 1,
      key: "name",
      name: t("INVENTORY_SETTINGS.CATEGORY.TABLE_COLUMN.CATEGORY_NAME"),
      render: (name: string) => {
        return (
          <Text weight="bold" color="info">
            {name}
          </Text>
        );
      },
    },
    {
      id: 2,
      key: "createdAt",
      name: t("INVENTORY_SETTINGS.CATEGORY.TABLE_COLUMN.DATA_OF_CREATION"),
      render: (createdAt: string) => {
        return (
          <Text color="subtitle2">
            {createdAt ? createdAt.split("T")[0] : "..."}
          </Text>
        );
      },
    },
    {
      id: 3,
      key: "id",
      name: "",
      render: (id: number | string, row: UnitType) => {
        return (
          <div
            onClick={() => {
              openConfirmationModel(row?.name, id);
            }}
            className="cursor-pointer"
          >
            <IconTrash01 size={24} fill="danger" />
          </div>
        );
      },
    },
    {
      id: 4,
      key: "id",
      name: "",
      render: (id: number | string) => {
        return (
          <div
            onClick={() => {
              handleScrollToTop();
              unitFetchByIdActionHandler(id);
            }}
            className="cursor-pointer"
          >
            <IconEdit01 size={24} />
          </div>
        );
      },
    },
  ];
};
